import { Builder } from '../api/builder'
import { MessageResource, UserResource } from '../api/config'

export const searchInbox = Builder(filters => MessageResource().get('/receive', {params: filters}))
export const sendMessage = Builder(info => MessageResource().post('/send', info))
export const viewMessageDetail = Builder(id => MessageResource().get('/detail', {params: {id: id}}))
export const viewSubscribes = Builder(() => MessageResource().get('/subscribe'))
export const subscribeMessage = Builder(() => UserResource().get('/subscribe'))
export const viewUnreadCount = Builder(() => MessageResource().get('/new'))